<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/procurement-management/approval-limits"
          ></back-button>
          Update Approval Limit
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/procurement-management/approval-limits`"
              >Approval Limits</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Effective Date</label>
              <div class="col-sm-10">
                <my-datepicker
                  :date.sync="form.effective_date"
                  placeholder="Enter Effective Date"
                ></my-datepicker>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Employee Role</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.employee_role_id"
                  :suggestions="employee_roles"
                  placeholder="Select employee role"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Approval Limit Upto</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.approval_limit_up_to"
                  class="form-control"
                  placeholder="Approval Limit Upto"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Currency</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.currency_id"
                  :suggestions="currencies"
                  placeholder="Select employee role"
                ></my-select>
              </div>
            </div>
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "Approval LimitUpdate",
  data() {
    return {
      form: {
        employee_role_id: "",
        currency_id: "",
      },
      employee_roles: [],
      currencies: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("approval_limits/masters");
      masters = masters.data;
      masters.employee_roles.forEach((employee_role) => {
        this.employee_roles.push({
          id: employee_role.id,
          name: employee_role.name,
        });
      });
      masters.currencies.forEach((currency) => {
        this.currencies.push({
          id: currency.id,
          name: currency.name,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/approval_limits/${this.$route.params.approval_limit_Id}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        this.form.edited_by_id = this.user.id;
        await axios.patch(
          `/approval_limits/${this.$route.params.approval_limit_Id}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/procurement-management/approval-limits");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
